import React from 'react'

function Divider({ title }) {
    return (
        <span className="relative flex justify-center items-center">
            <div
                className="absolute inset-x-0 top-1/2 h-px -translate-y-1/2 bg-transparent bg-gradient-to-r from-transparent via-[#3d0707] to-transparent opacity-85"
            ></div>

            <h4 className="relative bg-white px-6 font-black leading-none text-[#3d0707] uppercase text-center text-divide">{title}</h4>
        </span>
    )
}

export default Divider;